























import { Component, Vue, Prop } from 'nuxt-property-decorator';

import { IconArrowRight } from '@/icons';

@Component({
  components: {
    IconArrowRight,
  },
})
export default class BlockImageGallery extends Vue {
  // TODO: add bg type
  @Prop(String)
  backgroundColor!: string

  @Prop(String)
  title!: string

  // TODO: Add images type
  @Prop({ type: Array, required: true })
  images!: any

  get titleId () {
    return `block-image-gallery-title-${this._uid}`;
  }
}
